import { makeStyles } from '@material-ui/core/styles';

const useCommonStyles = makeStyles(() => {
    const style = {};	

    style['break_word'] = {
        wordWrap: 'break-word',
    }

    style['w_100p'] = {
        width: '100%',
    }

    return style;
});

export default useCommonStyles;